module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_bg01-6cd33466d89cc3c995e722569bf466a4.jpg";